import React, { CSSProperties, ReactNode } from 'react'

import { Text } from '../text'
import { Flex, Box } from '../box'
import { ThemeColors } from '../theme/colors'
import { TableCell } from './TableCell'

interface Props {
  bg?: ThemeColors
  'data-test-id'?: string
  stickyRightBorder?: boolean
  style?: CSSProperties
  title?: ReactNode
  titleCaption?: string
  titleInlineContent?: ReactNode
  width?: number | string
}

export function TableHeadCell({
  titleCaption,
  title,
  style,
  stickyRightBorder,
  width,
  titleInlineContent,
  bg,
  'data-test-id': dataTestId,
}: Props) {
  return (
    <TableCell
      alignItems='start'
      stickyRightBorder={stickyRightBorder}
      sticky
      style={style}
      width={width}
      data-test-id={dataTestId}
      isHeadCell
      bg={bg}
    >
      {titleCaption && (
        <Box>
          <Text style={{ color: '#9b9ea0' }} fontSize={12}>
            {titleCaption}
          </Text>
        </Box>
      )}
      {typeof title === 'string' ? (
        <Flex alignItems='center'>
          <Text color='neutral-dark-100' fontWeight={600}>
            {title}
          </Text>
          {titleInlineContent}
        </Flex>
      ) : (
        title
      )}
    </TableCell>
  )
}
